import { useState } from 'react';
import type { FaqItem } from '@/types/content';

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/60 md:px-6 md:py-5"
              >
                <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {item.question}
                </span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                    isOpen
                      ? 'border-primary-500 bg-primary-500 text-background-50'
                      : 'border-background-300 text-foreground-600'
                  }`}
                >
                  <i
                    className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="animate-fade px-5 pb-5 md:px-6">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}